/**
 * Static prototype stub — there is NO backend.
 *
 * The real app used this module as an authenticated fetch wrapper. In the
 * prototype all data comes from the in-memory mock store, so the network
 * helpers are gone. This file only keeps the few symbols other modules still
 * import (the session-expired plumbing and error class), as harmless no-ops.
 */

/** Custom error class for session expiration (never thrown in the prototype). */
export class SessionExpiredError extends Error {
  constructor(message: string = 'Sesión expirada') {
    super(message);
    this.name = 'SessionExpiredError';
  }
}

/**
 * Register a session-expiration callback. Kept for API compatibility with
 * AuthContext; sessions never expire in the static prototype, so this is a no-op.
 */
export function registerSessionExpiredHandler(_handler: () => void): void {
  // no-op
}
